module.exports = __webpack_public_path__ + "static/media/PC_Data_STORYTELLING_E_UX_PARA_NEGOCIOS.5080ed5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Storytelling/PC_Data_STORYTELLING_E_UX_PARA_NEGOCIOS.png
// module id = 69
// module chunks = 0